const turva2ColorTokens = {
  "color-turva2-red-00": "rgb(255, 242, 242)",
  "color-turva2-red-50": "rgb(255, 236, 236)",
  "color-turva2-red-100": "rgb(255, 229, 230)",
  "color-turva2-red-200": "rgb(255, 201, 204)",
  "color-turva2-red-300": "rgb(249, 164, 172)",
  "color-turva2-red-400": "rgb(243, 119, 133)",
  "color-turva2-red-500": "rgb(236, 69, 96)",
  "color-turva2-red-600": "rgb(230, 23, 64)",
  "color-turva2-red-700": "rgb(185, 3, 41)",
  "color-turva2-red-800": "rgb(140, 0, 30)",
  "color-turva2-red-900": "rgb(96, 0, 20)",
  "color-turva2-red-1000": "rgb(51, 0, 10)",
  "color-turva2-gray-00": "rgb(245, 246, 247)",
  "color-turva2-gray-50": "rgb(228, 233, 237)",
  "color-turva2-gray-100": "rgb(212, 221, 226)",
  "color-turva2-gray-200": "rgb(178, 194, 205)",
  "color-turva2-gray-300": "rgb(148, 169, 185)",
  "color-turva2-gray-400": "rgb(120, 145, 164)",
  "color-turva2-gray-500": "rgb(95, 122, 143)",
  "color-turva2-gray-600": "rgb(72, 100, 122)",
  "color-turva2-gray-700": "rgb(53, 79, 101)",
  "color-turva2-gray-800": "rgb(37, 60, 80)",
  "color-turva2-gray-900": "rgb(23, 42, 59)",
  "color-turva2-gray-1000": "rgb(6, 23, 38)",
  "color-turva-nude-00": "rgb(253, 247, 242)",
  "color-turva-nude-50": "rgb(251, 235, 225)",
  "color-turva-nude-100": "rgb(251, 225, 209)",
  "color-turva-nude-200": "rgb(241, 202, 178)",
  "color-turva-nude-300": "rgb(216, 174, 150)",
  "color-turva-nude-400": "rgb(190, 147, 124)",
  "color-turva-nude-500": "rgb(165, 122, 101)",
  "color-turva-nude-600": "rgb(140, 98, 79)",
  "color-turva-nude-700": "rgb(114, 76, 60)",
  "color-turva-nude-800": "rgb(89, 56, 43)",
  "color-turva-nude-900": "rgb(64, 38, 28)",
  "color-turva-nude-1000": "rgb(38, 21, 15)",
}

export default turva2ColorTokens
